<template lang="html">

  <div class="contenedor-popup row-center">

    <div class="info-popup">

      <a @click="$emit('close')" class="cerrar">✕</a>


      <h4>Evolución Precios fijo y coste de la energía </h4>

      <table class="tabla-precios" cellspacing="0">
        <thead>
          <tr>
            <td>Tramo</td>
            <td>Precio medio</td>
            <td>Precio Fijo</td>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!!getPrecios.tarifas_luz[type].fixed.p1">
            <td>P1</td>
            <td>{{mediap1 | comma}}€</td>
            <td>{{getPrecios.tarifas_luz[type].fixed.p1}}€</td>
          </tr>
          <tr v-if="!!getPrecios.tarifas_luz[type].fixed.p2">
            <td>P2</td>
            <td>{{mediap2 | comma}}€</td>
            <td>{{getPrecios.tarifas_luz[type].fixed.p2}}€</td>
          </tr>
          <tr v-if="!!getPrecios.tarifas_luz[type].fixed.p3">
            <td>P3</td>
            <td>{{mediap3 | comma}}€</td>
            <td>{{getPrecios.tarifas_luz[type].fixed.p3}}€</td>
          </tr>
        </tbody>
      </table>


      <div class="contenedor-grafica" v-if="series.length != 0">
        <apexchart height="200" type=area :options="chartOptions" :series="series" />
      </div>

      <div class="loading" v-else></div>
    </div>
  </div>

</template>

<script lang="js">

  import {mapGetters,mapActions } from 'vuex';

  import VueApexCharts from 'vue-apexcharts'

  export default {

    name: 'grafica-precio-coste',
    props: ['type'],
    data() {
      return {
        data: '',
        mediap1: '',
        mediap2: '',
        mediap3: '',
        series: [],
        chartOptions: {
          annotations: {
            yaxis: [],
          },
          colors: ['#EB5F0C', '#1E2E37', '#F6A910'],
          xaxis: {
            categories: []
          },
          fill: {
            opacity: 1

          },
          markers: {
            size: 4,
          },
          legend: {
            show: true,
            showForSingleSeries: true,
          },
          dataLabels: {
            enabled: false,
            position: 'top',
            style: {
              colors: ['#333']
            },
          },
          chart: {
            height: 400,
            background: 'white',
            type: "area",
            toolbar: {
              show: false
            },
          },
          stroke: {
            show: true,
            curve: 'smooth',
            lineCap: 'butt',
            colors: '#EB5F0C',
            width: 2,
            dashArray: 0,
          },
          tooltip: {
            enabled: true,
            style: {
              fontSize: '12px',
              color: 'red'
            }
          },
        }
      }
    },
    mounted() {
      this.setData();
    },
    methods : {
      ...mapActions(['requestHistorico']),
      setData(){
        this.requestHistorico().then(r => {
          let data = r[this.type].basic;

          this.chartOptions.xaxis.categories = new Array();

          Object.keys(data).forEach(e => {
            e = e.split("-").reverse().join("/");
            this.chartOptions.xaxis.categories.push(e);
          })

          let series = new Object();

          Object.keys(Object.values(data)[0]).forEach(e => {
            series[e] = {
              name : e,
              data : []
            }
          });

          
          Object.values(data).forEach(e => {
            
            Object.entries(e).forEach(v => {
              series[v[0]].data.push(v[1]);
            })
            
          })
          
          this.series = Object.values(series);

          this.mediap1 = (series.P1.data.reduce((a, b) => a + b, 0) / series.P1.data.length);
          this.mediap2 = (series.P2.data.reduce((a, b) => a + b, 0) / series.P2.data.length);
          this.mediap3 = (series.P3.data.reduce((a, b) => a + b, 0) / series.P3.data.length);

      
        })
      }
    },
    computed: {
      ...mapGetters(['getPrecios']),
      precios() {
        let precios = {
          P1: '',
          P2: '',
          P3: ''
        };

        if (!!this.getPrecios) {
          precios.P1 = (!!this.getPrecios.tarifas_luz[this.type].fixed.p1) ? Number(this.getPrecios.tarifas_luz[this.type].fixed.p1.replace(',', '.')) : null;
          precios.P2 = (!!this.getPrecios.tarifas_luz[this.type].fixed.p2) ? Number(this.getPrecios.tarifas_luz[this.type].fixed.p2.replace(',', '.')) : null;
          precios.P3 = (!!this.getPrecios.tarifas_luz[this.type].fixed.p3) ? Number(this.getPrecios.tarifas_luz[this.type].fixed.p3.replace(',', '.')) : null;
        }

        return precios;
      },

    },
    components: {
      'apexchart': VueApexCharts,
    }
  }
</script>

<style scoped lang="scss">
  .contenedor-popup {
    padding: 15px;
    z-index: 25;
  }

  .contenedor-grafica {
    padding: 10px;
    background: white;
    margin-top: 30px;
  }

  .info-popup {
    max-width: 768px;
    max-height: 100%;
  }

  .tarifa-el .datos-tarifa .cerrar {
    text-align: center;
    right: 10px;
  }

  .loading {
    height: 255px;
    margin-top: 30px;
    background: url(/static/img/loading-white.svg) center no-repeat;
  }

  .tabla-precios {
    width: 100%;
    max-width: 320px;
    cellspacing: 0px;
    cellpadding: 5px;

    td {
      min-width: 80px;
    }

    thead {
      td {
        font-weight: 800;
      }
    }

    tbody {
      td {
        border-bottom: 1px solid #ffffff;
        padding: 5px 0;
      }

      td:first-of-type {
        font-weight: 800;
      }

      tr:last-of-type {
        td {
          border-bottom: none;
        }
      }
    }
  }

  @media screen and (max-width: 520px) {
    .tarifa-el .datos-tarifa .cerrar {
      left: auto;
      width: 40px;
      height: 40px;
      top: 10px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/grafica-precio-coste.vue